export enum TagType {
  Alerts = 'Alerts',
  Acl = 'Acl',
  AlgorithmMetrics = 'algorithmMetrics',
  ApiKey = 'ApiKey',
  Automation = 'Automation',
  ClauseLibrary = 'ClauseLibrary',
  ClauseLibraryV2 = 'ClauseLibraryV2',
  Clients = 'Clients',
  CodeCash = 'CodeCash',
  Comment = 'Comment',
  ConversationalAi = 'ConversationalAi',
  CrmConnections = 'CrmConnections',
  DataFields = 'DataFields',
  DashboardV2 = 'DashboardV2',
  Department = 'Department',
  Document = 'Document',
  DocumentRestore = 'DocumentRestore',
  EsignatureActivities = 'EsignatureActivities',
  EsignatureIntegrations = 'EsignatureIntegrations',
  EsignatureEnvelope = 'EsignatureEnvelope',
  EsignatureTokenStatus = 'EsignatureTokenStatus',
  Fields = 'Fields',
  Folder = 'Folder',
  Groups = 'Groups',
  Guidelines = 'Guidelines',
  Highlight = 'Highlight',
  LibraryModel = 'LibraryModel',
  LibraryModels = 'LibraryModels',
  Parties = 'Parties',
  PromptModel = 'PromptModel',
  PromptModelProgress = 'PromptModelProgress',
  PromptModelResult = 'PromptModelResult',
  PromptModelSummary = 'PromptModelSummary',
  Playbooks = 'Playbooks',
  PlaybookTemplates = 'PlaybookTemplates',
  Clauses = 'Clauses',
  Question = 'Question',
  QuestionGroup = 'QuestionGroup',
  Roles = 'Roles',
  SaveSearch = 'SaveSearch',
  SearchV3 = 'SearchV3',
  SharepointConfiguration = 'SharepointConfiguration',
  SharepointOpenDocument = 'SharepointOpenDocument',
  SmartClause = 'SmartClause',
  Sylvanus = 'Sylvanus',
  TableViews = 'TableViews',
  Ticket = 'Ticket',
  TicketRecipients = 'TicketRecipients',
  TurnTracking = 'TurnTracking',
  UploadFiles = 'UploadFiles',
  UserPreferences = 'UserPreferences',
  Users = 'Users',
  Webhooks = 'Webhooks',
  Workflows = 'Workflows',
  Routings = 'Routings',
  TicketK2 = 'TicketK2',
}
